<div [class]="divClass">
  <label *ngIf="showLabel" [class]="labelClass">{{
    "DropDowns.Label.Facility" | translate
  }}</label>

  <p-multiSelect
    *ngIf="isMultiple"
    appendTo="body"
    [style]="dropdownStyle"
    [disabled]="disabled"
    placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
    [filter]="showFilter"
    [options]="facilityOptionsByPermission"
    [ngModel]="facilityDataList"
    (ngModelChange)="onChange($event)"
    [virtualScroll]="virtualScroll"
    [itemSize]="40"
    [showToggleAll]="showToggleAll"
  >
    <ng-template pTemplate="selectedItems" let-value>
      <ng-container *ngIf="!value || value.length === 0; else showData">
        <span>
          {{ "Common.Message.ChooseOption" | translate }}
        </span>
      </ng-container>
      <ng-template #showData>
        <span *ngFor="let val of value; first as isFirst">
          <ng-container *ngIf="!isFirst">, </ng-container>
          {{ val | optionsMapping : facilityOptionsByPermission }}
        </span>
      </ng-template>
    </ng-template>
  </p-multiSelect>

  <p-dropdown
    *ngIf="isSingle"
    appendTo="body"
    [style]="dropdownStyle"
    [disabled]="disabled"
    [filter]="showFilter"
    placeholder="{{ 'Common.DropDown.Select' | translate }}"
    [options]="facilityOptionsByPermission"
    [showClear]="showClear"
    [itemSize]="40"
    [virtualScroll]="virtualScroll"
    [ngModel]="facilityData"
    (ngModelChange)="onChange($event)"
  >
  </p-dropdown>

  <p-dropdown
    *ngIf="isIcon"
    appendTo="body"
    panelStyleClass="custom-dropdown-panel"
    class="iconDropdown"
    [disabled]="disabled"
    [filter]="showFilter"
    [options]="facilityOptionsByPermission"
    placeholder="{{ 'Common.DropDown.Select' | translate }}"
    [showClear]="showClear"
    [itemSize]="40"
    [virtualScroll]="virtualScroll"
    [ngModel]="facilityData"
    (ngModelChange)="onChange($event)"
  >
    <!-- 顯示已選項目：只顯示 facilityData.value -->
    <ng-template let-facility pTemplate="selectedItem">
      <div>{{ facility?.value }}</div>
    </ng-template>
    <!-- 下拉選單項目：顯示 label -->
    <ng-template let-facility pTemplate="item">
      <div>{{ facility?.label }}</div>
    </ng-template>
    <!-- 下拉 icon -->
    <ng-template pTemplate="dropdownicon">

    </ng-template>
  </p-dropdown>
</div>
